import axios, { AxiosInstance } from 'axios';
import { AxiosCacheInstance, setupCache } from 'axios-cache-interceptor';
import { store } from 'store/index';

export const apiInstance = (timeout = 100000): AxiosInstance => {
	const axiosInstance = axios.create({
		timeout,
	});

	// add X-Site-Name header to requests
	// const theme = 'CODAN';
	// axios.defaults.headers.common['X-Site-Name'] = theme;

	// Add the error handling interceptor
	axiosInstance.interceptors.response.use(
		(response) => response.data,
		(error) => {
			console.error('API error', error);
			throw error;
		}
	);

	return axiosInstance;
};

let axiosCacheInstance: AxiosCacheInstance;
export const apiInstanceCached = (): AxiosCacheInstance => {
	if (axiosCacheInstance) {
		return axiosCacheInstance;
	}

	const axiosInstance = axios.create({
		timeout: 65000,
	});

	axiosCacheInstance = setupCache(axiosInstance, {
		ttl: 1000 * 60 * 10, // 10 minutes cache
		methods: ['get', 'post'],
		interpretHeader: false, // override no-cache
	});

	// add request interceptor here if needed
	axiosInstance.interceptors.response.use(
		(response) => ({ ...response.data, axiosCached: (response as any).cached }),
		(error) => {
			console.error('API error', error);
			throw error;
		}
	);

	return axiosCacheInstance;
};

export const getProxyUrl = (metaAreaContent: MetaAreaContent, url: string) => {
	if (!url || !metaAreaContent) {
		return;
	}
	const isLoggedIn = store.getState().customer.isLoggedIn;

	let baseUrl = metaAreaContent.content.baseUrlOpenProxy.url;

	if (isLoggedIn) {
		baseUrl = metaAreaContent.content.baseUrlAuthenticatedProxy.url;
	}
	console.log('baseUrl', baseUrl);

	return baseUrl + url;
};
